import * as React from 'react'

import { Popup } from 'react-map-gl/mapbox'

import { ResourceCard } from '~/client/src/shared/components/ResourceCardList/ResourceCard'
import { IResourceCardModel } from '~/client/src/shared/components/ResourceCardList/types'
import { renderResourceSemanticIcon } from '~/client/src/shared/resources/icons/resourceSemanticIcons'

interface IProps {
  longitude: number
  latitude: number
  model: IResourceCardModel
  recordId: string
  leading?: React.ReactNode
  onClose: () => void
  onOpen: (id: string) => void
}

const EquipmentMapPopup: React.FC<IProps> = ({
  longitude,
  latitude,
  model,
  recordId,
  leading,
  onClose,
  onOpen,
}) => {
  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      closeButton={false}
      closeOnClick={true}
      onClose={onClose}
      className="resource-card-mapbox-popup"
      offset={24}
    >
      <ResourceCard.PopupStandard
        model={model}
        onClose={onClose}
        onClick={() => onOpen(recordId)}
        leading={
          leading ??
          renderResourceSemanticIcon(
            'equipment',
            'tw:block tw:size-full tw:text-muted-foreground',
          )
        }
      />
    </Popup>
  )
}

export default EquipmentMapPopup
